function isSalaryVisible(companyName: string): boolean {
  return companyName !== 'Duke Health'
}

export default isSalaryVisible
